export default "__VITE_ASSET__de3e4d35__"